import { Component, inject } from '@angular/core';
import { SmartAssistantImportService } from '../smart-assistant-import.service';

@Component({
    standalone: false,
    selector: 'app-smart-assistant-product-step',
    templateUrl: './smart-assistant-product-step.component.html'
})
export class SmartAssistantProductStepComponent {
    readonly service = inject(SmartAssistantImportService);

    updateProduct(event: Event & { target: HTMLSelectElement }): void {
        this.service.updateProductId(event.target.value || null);
    }
}
